var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7998 8.74421V10.7522C2.7998 11.0565 2.91043 11.3484 3.10734 11.5635C3.30426 11.7787 3.57133 11.8996 3.8498 11.8996H10.1498C10.4283 11.8996 10.6954 11.7787 10.8923 11.5635C11.0892 11.3484 11.1998 11.0565 11.1998 10.7522V8.74421M7.0003 2.09961L7.0003 8.60164M7.0003 8.60164L4.6003 6.11724M7.0003 8.60164L9.4003 6.11724",
    stroke: "#007FFF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconPortfolio);
export default __webpack_public_path__ + "static/media/downloadIconPortfolio.e3f1e1e4a4fa24e86903bf93b0940cb5.svg";
export { ForwardRef as ReactComponent };